import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79142c2e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "d-flex flex-column align-center overflow-auto",
  style: {"height":"100%","padding-top":"var(--top-offset)"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "kirjeldus pa-4" }, " Kriminaalhooldusportaali eesmärk on toetada kriminaalhoolduse läbimist ning olla kasutaja virtuaalne toimik. ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "kirjeldus pa-4 mb-12" }, [
  /*#__PURE__*/_createTextVNode(" Kui Teil on riigi poolt kättetoimetamist vajavaid dokumente, siis suunatakse Teid esmalt Kättetoimetamise portaali. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Kui Te pole dokumente vastu võtnud, ei ole võimalik portaali kasutada. ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_DefaultLayout = _resolveComponent("DefaultLayout")!

  return (_openBlock(), _createBlock(_component_DefaultLayout, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_container, {
        fluid: "",
        style: {"overflow-y":"auto","height":"100%"},
        class: "pt-0"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _hoisted_2,
            _hoisted_3,
            _createElementVNode("div", null, [
              _createVNode(_component_v_btn, {
                color: "primary",
                onClick: _ctx.logiSisse
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Sisene")
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}